import React, { useState, useEffect } from 'react';

const RSVPPreview = ({ data }) => {
    const [name, setName] = useState("");
    const [attendance, setAttendance] = useState(null);
    const [btnState, setBtnState] = useState("idle");

    useEffect(() => {
        let mounted = true;

        const runSequence = async () => {
            // Loop indefinitely
            while (mounted) {
                // RESET
                setName("");
                setAttendance(null);
                setBtnState("idle");

                await new Promise(r => setTimeout(r, 1000));
                if (!mounted) break;

                // TYPE NAME
                const fullName = "Mario Rossi";
                for (let i = 0; i <= fullName.length; i++) {
                    if (!mounted) break;
                    setName(fullName.slice(0, i));
                    await new Promise(r => setTimeout(r, 100)); // Typing speed
                }

                await new Promise(r => setTimeout(r, 800));
                if (!mounted) break;

                // SELECT ATTENDANCE
                setAttendance("Sì, ci sarò");

                await new Promise(r => setTimeout(r, 1000));
                if (!mounted) break;

                // CLICK SUBMIT
                setBtnState("active");
                await new Promise(r => setTimeout(r, 200));
                setBtnState("sent");

                await new Promise(r => setTimeout(r, 3000)); // Wait before restart
            }
        };

        runSequence();
        return () => { mounted = false; };
    }, []);

    return (
        <div className="w-full h-full flex items-center justify-center bg-[#fbf9f5] relative overflow-hidden font-serif">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-40 mix-blend-multiply" style={{ backgroundImage: `url(${data.bgPattern})` }}></div>

            {/* Card Form */}
            <div className="relative z-10 w-[85%] bg-white/90 backdrop-blur-sm p-8 shadow-2xl rounded-sm border border-stone-200 flex flex-col items-center text-center">

                {/* Header */}
                <h2 className="text-5xl font-serif text-stone-800 mb-4 tracking-[0.2em] uppercase">RSVP</h2>
                <div className="w-8 h-[1px] bg-stone-300 mb-6" />
                <p className="text-[8px] uppercase tracking-[0.3em] text-stone-500 font-sans mb-10 font-medium">
                    Entro il 15 Agosto
                </p>

                {/* Fake Form Fields */}
                <div className="w-full space-y-8">
                    {/* Input Name */}
                    <div className="group w-full text-left relative">
                        <div className="w-full border-b border-stone-300 py-1 text-base min-h-[32px] flex items-center">
                            {name ? (
                                <>
                                    <span className="text-stone-800 font-serif">{name}</span>
                                    {btnState === 'idle' && name.length < 11 && <span className="w-[1px] h-5 bg-stone-800 ml-0.5 animate-pulse" />}
                                </>
                            ) : (
                                <span className="text-stone-400 font-serif italic text-sm">Nome e Cognome</span>
                            )}
                        </div>
                    </div>

                    {/* Input Attendance */}
                    <div className="group w-full text-left">
                        <div className="w-full border-b border-stone-300 py-1 text-base flex justify-between items-center min-h-[32px]">
                            <span className={attendance ? "text-stone-800 font-serif" : "text-stone-400 font-serif italic text-sm"}>
                                {attendance || "Parteciperai?"}
                            </span>
                            <span className="text-[8px] text-stone-400">▼</span>
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className={`pt-4 transition-all duration-500 transform ${btnState === 'active' ? 'scale-95' : 'scale-100'}`}>
                        <div className={`w-full py-3 text-[9px] font-sans font-semibold uppercase tracking-[0.25em] rounded-sm shadow-md transition-all duration-500 flex items-center justify-center gap-2
                            ${btnState === 'sent' ? 'bg-emerald-700 text-white shadow-emerald-700/20' : 'bg-stone-800 text-white shadow-stone-800/20 hover:bg-stone-900'}`}>
                            {btnState === 'sent' ? (
                                <span className="flex items-center gap-2">Confermato</span>
                            ) : (
                                'Conferma'
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const RSVPOverlay = ({ data }) => (
    <div className="flex flex-col h-full text-center md:text-left">
        <span className="text-lime-600 font-bold tracking-widest uppercase text-[10px] mb-3 block">Dettagli</span>
        <h3 className="text-3xl font-serif text-slate-800 mb-4">{data.overlayTitle}</h3>
        <p className="text-slate-600 text-sm leading-relaxed font-light mb-8">
            {data.description}
        </p>

        <ul className="space-y-3 mb-8 text-left bg-slate-50 p-6 rounded-xl border border-slate-100">
            {data.bullets && data.bullets.map((bullet, i) => (
                <li key={i} className="flex items-start gap-3">
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-lime-500 shrink-0" />
                    <span className="text-slate-700 text-sm font-medium">{bullet}</span>
                </li>
            ))}
        </ul>

        {data.techNote && (
            <div className="mt-auto pt-4 border-t border-slate-100">
                <code className="text-[10px] font-mono text-slate-400 block mb-1">TECH STACK</code>
                <code className="text-xs font-mono text-lime-700">{data.techNote}</code>
            </div>
        )}
    </div>
);

export default RSVPPreview;
